import { WorkflowApp } from 'api/wfApi';
import { Button } from 'components/basic/button';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import urls from 'urls';

interface SettingButtonProps {
  workflowApp: WorkflowApp;
  disabled: boolean;
}

export const SettingButton = (props: SettingButtonProps) => {
  const { workflowApp, disabled } = props;
  const navigate = useNavigate();

  // アプリの詳細設定画面に遷移
  const onSettingButton = useCallback(() => {
    navigate(`${urls.SETTINGS}/${workflowApp.id.toString()}`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div>
      <Button onClick={onSettingButton} disabled={disabled}>設定</Button>
    </div>
  );
};
